module.exports = __webpack_public_path__ + "img/nita.92b19847.png";